import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { foodList, getFood } from "../../../data/foodList";
import { getRestaurant } from "../../../data/restaurant";
import { locationIcon } from "../../../locationIcon";
import { Type } from "../../../types";
import styles from "./style.module.css";

const FoodItemPage = () => {
  let { id } = useParams();
  const food = getFood(id);
  const navigate = useNavigate();

  //   const food = foodList.find((food) => food.id === id);
  if (!food) return <div>Error!</div>;
  const restaurant = getRestaurant(food.restaurantId);

  return (<>
  <div className={styles.backbtn} onClick={() => navigate('/')}>Back</div>
    <div className={styles.card}>
      <div className={styles.left}>
        <img src={food.image} alt={food.name} className={styles.image} />
      </div>
      <div>
        <div>
          <div className={styles.foodname}>{food.name}</div>
        </div>
        <div className={styles.typeWrap} style={{ width: "fit-content" }}>
          <div
            style={{ background: food.type === Type.Veg ? "green" : "red" }}
            className={styles.dot}
          />
          {food.type}
        </div>

        {restaurant.name && <div className={styles.restname}>
          <span className="by">by </span>
          {restaurant.website ? (
            <a
              href={restaurant.website}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              {restaurant.name}
            </a>
          ) : (
            restaurant.name
          )}
        </div>}

        {food.description && <div className={styles.desc}>{food.description}</div>}

        <div>
          {food.labels.map((label) => (
            <span className="label">{label}</span>
          ))}
        </div>

        <div className={styles.loc}>
          <span>{locationIcon}</span>
          {restaurant.location.url ? (
            <a
              href={restaurant.location.url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              {restaurant.location.place}
            </a>
          ) : (
            restaurant.location.place
          )}
        </div>

        <div></div>
      </div>
    </div>
    <div style={{minHeight: 20}}></div>
    </>
  );
};

export default FoodItemPage;
